import React from 'react';
import FeatureCards from "../../../components/FeatureCards/FeatureCards";
import CTA from "../../../components/Constant/cta/CTA";
import TimelineSection from "../../../components/TimelineSection/TimelineSection";
import WhySection from "../../../components/WhySection/WhySection";
import LocationTimeline from "../../../components/LocationTimeline/LocationTimeline";
import IntroSection from "../../../components/IntroSection/IntroSection";
import FAQList from "../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../../components/InfoBlocks/InfoBlocks";
import ServiceCards from "../../../components/ServiceCards/ServiceCards";

export default function RealEstateInvestmentGreece() {

    return (
        <main className='main'>
            <IntroSection
                title="Real Estate Investment in Greece"
                subtitle="Secure EU Residency & Long-Term Benefits Through Property"
                description="Greece offers one of Europe’s most attractive residency-by-investment pathways through its Golden Visa program. By investing in Greek real estate, investors gain access to the EU and Schengen Zone while benefiting from property appreciation, strong rental yields, and strategic tax advantages."
                badges={[
                    "Golden Visa Residency",
                    "€250,000 Investment Threshold",
                    "EU Access"
                ]}
                buttonText="Request a Greece Real Estate Consultation →"
                buttonLink="/quote"
                imageSrc={require('../../../assets/images/real-estate/real-estate-investment-greece.png')}
                imageAlt="Greece Real Estate Investment"
            />

            <section className='section'>
                <div className="container">
                    <WhySection
                        title="Why Invest in Greek Real Estate?"
                        blocks={[
                            {
                                items: [
                                    { title: "Low Entry Point", text: "Only €250,000 — the lowest real estate residency threshold in the EU." },
                                    { title: "Residency for the Whole Family", text: "Covers spouse, children, and dependent parents." },
                                    { title: "Free Movement", text: "Visa-free travel across all Schengen countries." },
                                    { title: "Lifestyle & Tourism Demand", text: "High rental yields in Athens, Thessaloniki, Crete, and major islands." },
                                    { title: "Tax Advantages", text: "Combine investment with Greece’s Non-Dom €100k flat tax regime." },
                                    { title: "EU Citizenship Path", text: "Eligible for citizenship after 7 years of residence." }
                                ]
                            }
                        ]}
                    />

                    <InfoBlocks
                        title="Golden Visa via Real Estate"
                        blocks={[
                            {
                                items: [
                                    { text: "Minimum €250,000 investment in eligible real estate." },
                                    { text: "5-year residency, renewable indefinitely." },
                                    { text: "Includes apartments, villas, commercial assets, and tourist properties." },
                                    { text: "Fast approval timeline: 2–4 months." },
                                    { text: "Family coverage includes spouse, children under 21, and parents of both spouses." }
                                ]
                            }
                        ]}
                    />

                    <InfoBlocks
                        title="Best Areas for Investment"
                        blocks={[
                            {
                                items: [
                                    { text: "Athens (Attica Region) – strong rental yields and urban demand." },
                                    { text: "Thessaloniki – cultural hub with university-driven rental demand." },
                                    { text: "Crete & Rhodes – ideal for holiday homes and seasonal rentals." },
                                    { text: "Santorini & Mykonos – premium luxury tourism markets." },
                                    { text: "Peloponnese & Halkidiki – emerging markets with affordable opportunities." }
                                ]
                            }
                        ]}
                    />

                    <ServiceCards
                        title="Typical Investment Models"
                        services={[
                            { title: "Residential Apartments & Villas", text: "Suitable for personal use or long-term/short-term rentals." },
                            { title: "Tourism Properties", text: "Hotels, resorts, and guesthouses offering strong seasonal income." },
                            { title: "Commercial Real Estate", text: "Offices, retail stores, and mixed-use buildings." },
                            { title: "Mixed-Use Developments", text: "Projects combining residential, retail, and hospitality." }
                        ]}
                    />

                    <WhySection
                        title="Advantages of Greece Real Estate Residency"
                        blocks={[
                            {
                                items: [
                                    { title: "EU Residency with Family Inclusion", text: "All dependents included under one investment." },
                                    { title: "No Stay Requirement", text: "Residency can be maintained without living in Greece." },
                                    { title: "Tax Planning Opportunities", text: "Greek Non-Dom regime for global income optimization." },
                                    { title: "Property Value Growth", text: "Demand rising in both cities and tourist destinations." },
                                    { title: "Dual Strategy", text: "Use the property for lifestyle AND rental yield." }
                                ]
                            }
                        ]}
                    />

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <CTA
                        title="Ready to invest in Greece real estate and secure EU residency?"
                        description="Offshore Advisory provides property sourcing, Golden Visa applications, and tax structuring advice."
                        buttonText="Book a Greece Real Estate Investment Consultation Today →"
                        buttonLink="/quote"
                    />

                </div>
            </section>
        </main>
    );
};

const faqData = [
    {
        question: "What is the minimum property investment for residency?",
        content: [
            { type: "answer", text: "€250,000 in real estate." }
        ],
    },
    {
        question: "Can I rent out my property?",
        content: [
            { type: "answer", text: "Yes, both short-term (Airbnb) and long-term rentals are allowed." }
        ],
    },
    {
        question: "Does property investment lead to citizenship?",
        content: [
            { type: "answer", text: "Yes, after 7 years of legal residence." }
        ],
    },
    {
        question: "Can multiple properties be combined to reach €250k?",
        content: [
            { type: "answer", text: "Yes, investors can combine properties to meet the threshold." }
        ],
    },
    {
        question: "How long does the Golden Visa process take?",
        content: [
            { type: "answer", text: "Typically 2–4 months." }
        ],
    },
];
